module.exports = __webpack_public_path__ + "img/Icon_EmployeeWellness.4fa38f83.png";